import { Box, Button, Card, FormControl, FormControlLabel, Grid, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Controller, set, useForm } from 'react-hook-form';
import { GstDataContext } from './Gst';
import { GstServices } from './services';
import Swal from 'sweetalert2';
import { PermissionGuard } from '../../../../components/PermissionGuard';
import UnauthorizedPage from '../../../UnAuthorized';

const gstSlabs = [
    { value: '0', label: '0 % ',for: ' Exempt/Nil Rate' },
    // { value: '0.25', label: '0.25 % ',for: ' Cut & Polished Diamonds' },
    // { value: '1.5', label: '1.5 % ',for: ' Special Rate' },
    // { value: 3, label: '3 % ',for: ' Gold & Precious Stones' },
    { value: 5, label: '5 % ',for: ' Essential Items' },
    { value: 12, label: '12 % ',for: ' Standard Rate 1' },
    { value: 18, label: '18 % ',for: ' Standard Rate 2' },
    { value: 28, label: '28 % ',for: ' Luxury Items' }
  ];

const AddEdit = () => {
    const {gstInitialData,gstData,setGstData,fetchGstList,selectedGstData, setSelectedGstData} = useContext(GstDataContext)
    const [pageTitle, setPageTitle] = useState('Add GST');
    const {control,handleSubmit,formState:{errors,isDirty},reset,watch,setValue,clearErrors} = useForm({
        mode:'onChange',
        defaultValues:gstData,
    });
    const [isSubmitted,setIsSubmitted] = useState(false);
    const onSubmit = async (data)=>{
        setIsSubmitted(true);
        console.log("data:",data);
        const ModifiedData = {
            sac: data.sac,
            rcm: data.rcm,
            igst: data.igst,
            cgst: data.cgst ,
            sgst: data.sgst,
            igstNon: data.igstNon,
            cgstNon: data.cgstNon,
            sgstNon: data.sgstNon,
            tcs: data.tcs,
            title:data.title
        }
        try{
            if(selectedGstData){
                //update
                const updateresponse = await GstServices.updateGst(ModifiedData,selectedGstData.id);
                if(updateresponse.success == '1'){
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Data updated successfully',
                    })
                    fetchGstList();
                    setSelectedGstData(null);
                    setGstData(gstInitialData);
                    reset(gstInitialData);
                }else if(updateresponse.success == '0'){                    
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: updateresponse.message || 'failed to update data',
                    })
                }
            }else{
                //save
                const saveresponse = await GstServices.addGst(ModifiedData);
                if(saveresponse.success == '1'){
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Data saved successfully',
                    })
                    fetchGstList();
                    reset(gstInitialData);
                }else if(saveresponse.success == '0'){
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: saveresponse.message || 'failed to save data',
                    })
                }
            }
        }catch (error){
            console.log("error:",error)
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'failed to save data...Something went wrong!',
            })
        }finally{
            setIsSubmitted(false);
        }
    }
    useEffect(()=>{
        if(selectedGstData){
            setPageTitle('Edit GST');
            const modifiedData = {
                ...selectedGstData,
                taxSlab:selectedGstData.igst,
            }
            setGstData(modifiedData);
            reset(modifiedData,{isDirty:false});
        }
    },[selectedGstData])

    const taxSlab = watch('taxSlab');
    useEffect(()=>{
        if(taxSlab){
            const gstSlab = gstSlabs.find(slab=>slab.value == taxSlab);
            setValue('igst',gstSlab?.value);
            setValue('cgst',gstSlab?.value/2);
            setValue('sgst',gstSlab?.value/2);
        }
    },[taxSlab])

    const rcm = watch('rcm');
    useEffect(()=>{
        if(rcm){
            if(rcm){
                setValue('igstNon',5,{shouldValidate:true});
                setValue('cgstNon',2.5,{shouldValidate:true});
                setValue('sgstNon',2.5,{shouldValidate:true});
                setValue('tcs',0,{shouldValidate:true});
            }
        }else {
            setValue('igstNon',0,{shouldValidate:true});
            setValue('cgstNon',0,{shouldValidate:true});
            setValue('sgstNon',0,{shouldValidate:true});
            setValue('tcs',1)
        }
    },[rcm]);
    const Submitting = ()=>{
        Swal.fire({
            title: 'Please wait...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });
    }
    const resetFormField = ()=>{
        reset(gstInitialData);
        setSelectedGstData(null);
        setGstData(gstInitialData);
    }
  return (
    <PermissionGuard feature="gst" permission={selectedGstData ?'canEdit':"canCreate"} fallback={selectedGstData && <UnauthorizedPage/>}>
        <Card>
            {isSubmitted && Submitting()}
            <Box sx={{p:'.5% 1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
                <Typography sx={{fontWeight:600,fontSize:'0.85rem'}} >{pageTitle}</Typography>
            </Box>
            <Box component={'form'} onSubmit={handleSubmit(onSubmit)} sx={{p:1}}>
                
                <Grid container spacing={2}>
                    <Grid item xs={5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Sac Code <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Controller
                            name='sac'
                            control={control}
                            rules={{
                                required:'Enter SacCode',
                                validate: value => {
                                    // If there is a value, ensure it's a positive integer
                                    if (Number(value) <= 0) {
                                        return 'Please enter a positive number';
                                    }
                                    return true;
                                }
                            }}
                            render={({field,fieldState:{error}})=>
                                <TextField
                                    {...field}
                                    size='small'
                                    fullWidth
                                    type='number'
                                    error={!!error}
                                    inputProps={{
                                        style:{
                                            fontSize:'0.65rem'
                                        },
                                        onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                        onKeyDown: (e) => {
                                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                e.preventDefault();
                                            }
                                        }
                                    }}
                                    onChange={(e) => {
                                        const inputValue = e.target.value;
                                        // Allow empty value
                                        if (inputValue === '') {
                                            field.onChange('');
                                            return;
                                        }

                                        let value = formatValue(parseInt(e.target.value));
                                        if (value < 0 || isNaN(value)) {
                                            value = 0;
                                        }
                                        field.onChange(value);
                                    }}
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={2}/>
                    <Grid item xs={5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Tax Slab <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Controller
                            control={control}
                            name="taxSlab"
                            rules={{
                                required:'select Tax Slab',
                            }}
                            render={({field,fieldState:{error}})=>(
                                <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                                    <Select
                                        {...field}
                                        error={!!error}
                                        sx={{
                                            fontSize:'0.65rem',
                                        }}
                                    >
                                        { gstSlabs.map((slab,index)=>(
                                            <MenuItem key={index} value={slab.value} sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>{slab.label}</MenuItem>                                   
                                        ))}
                                    </Select>
                                </FormControl>
                            )}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>IGST</Typography>
                        <Controller
                            control={control}
                            name="igst"
                            render={({field,fieldState:{error}})=>(
                                <TextField
                                    {...field}
                                    size='small'
                                    fullWidth
                                    disabled
                                    inputProps={{
                                        style:{fontSize:'0.65rem'}
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>CGST</Typography>
                        <Controller
                            control={control}
                            name="cgst"
                            render={({field,fieldState:{error}})=>(
                                <TextField
                                    {...field}
                                    size='small'
                                    fullWidth
                                    disabled
                                    inputProps={{
                                        style:{fontSize:'0.65rem'}
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>SGST</Typography>
                        <Controller
                            control={control}
                            name="sgst"
                            render={({field,fieldState:{error}})=>(
                                <TextField
                                    {...field}
                                    size='small'
                                    fullWidth
                                    disabled
                                    inputProps={{
                                        style:{fontSize:'0.65rem'}
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600 }}>RCM <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box> : </Typography>
                        <Controller
                            name='rcm'
                            control={control}
                            rules={{
                                validate: value => {
                                    return true;
                                }
                            }}
                            render={({field,fieldState:{error}})=>
                                <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                                    <Select
                                        {...field}
                                        error={!!error}
                                        sx={{
                                            fontSize:'0.65rem',
                                        }}
                                    >                                    
                                        <MenuItem value={true} sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>True</MenuItem>
                                        <MenuItem value={false} sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>False</MenuItem>                                   
                                    </Select>
                                </FormControl>
                            }
                        />
                    </Grid>
                    <Grid item xs={2} />
                    <Grid item xs={5}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>TCS</Typography>
                        <Controller
                            name='tcs'
                            control={control}
                            rules={{
                                required:'TCS required',
                            }}
                            render={({field,fieldState:{error}})=>
                                <TextField
                                    {...field}
                                    size='small'
                                    // fullWidth
                                    type='number'
                                    // disabled
                                    inputProps={{
                                        style:{fontSize:'0.65rem'}
                                    }}
                                    onChange={(e) => {
                                        let value = e.target.value;
                        
                                        // Allow a single '0', but remove leading zeros from other numbers
                                        if (value.length > 1) {
                                            value = value.replace(/^0+/, ""); 
                                        }
                        
                                        field.onChange(value === "" ? "" : Number(value));
                                    }}
                                    error={!!error}
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>IGST_Non</Typography>
                        <Controller
                            control={control}
                            name="igstNon"
                            rules={{
                                required:'IGST_Non required'
                            }}
                            render={({field,fieldState:{error}})=>(
                                <TextField
                                    {...field}
                                    size='small'
                                    fullWidth
                                    // disabled
                                    type='number'
                                    inputProps={{
                                        style:{fontSize:'0.65rem'}
                                    }}
                                    onChange={(e) => {
                                        let value = e.target.value;
                        
                                        // Allow a single '0', but remove leading zeros from other numbers
                                        if (value.length > 1) {
                                            value = value.replace(/^0+/, ""); 
                                        }
                        
                                        field.onChange(value === "" ? "" : Number(value));
                                    }}
                                    error={!!error}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>CGST_Non</Typography>
                        <Controller
                            control={control}
                            name="cgstNon"
                            rules={{
                                required:'CGST_Non required'
                            }}
                            render={({field,fieldState:{error}})=>(
                                <TextField
                                    {...field}
                                    size='small'
                                    fullWidth
                                    // disabled
                                    type='number'
                                    inputProps={{
                                        style:{fontSize:'0.65rem'}
                                    }}
                                    onChange={(e) => {
                                        let value = e.target.value;
                        
                                        // Allow a single '0', but remove leading zeros from other numbers
                                        if (value.length > 1) {
                                            value = value.replace(/^0+/, ""); 
                                        }
                        
                                        field.onChange(value === "" ? "" : Number(value));
                                    }}
                                    error={!!error}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>SGST_Non</Typography>
                        <Controller
                            control={control}
                            name="sgstNon"
                            rules={{
                                required:'SGST_Non required'
                            }}
                            render={({field,fieldState:{error}})=>(
                                <TextField
                                    {...field}
                                    size='small'
                                    fullWidth
                                    // disabled
                                    type='number'
                                    inputProps={{
                                        style:{fontSize:'0.65rem'}
                                    }}
                                    onChange={(e) => {
                                        let value = e.target.value;
                        
                                        // Allow a single '0', but remove leading zeros from other numbers
                                        if (value.length > 1) {
                                            value = value.replace(/^0+/, ""); 
                                        }
                        
                                        field.onChange(value === "" ? "" : Number(value));
                                    }}
                                    error={!!error}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Title <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Controller
                            name='title'
                            control={control}
                            rules={{
                                required:'title required',
                            }}
                            render={({field,fieldState:{error}})=>
                                <TextField
                                    {...field}
                                    size='small'
                                    fullWidth
                                    // type='number'
                                    error={!!error}
                                    inputProps={{
                                        style:{
                                            fontSize:'0.65rem'
                                        },
                                    }}
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={12} sx={{display:'flex',justifyContent:'center',gap:2}}>
                        <Button 
                            variant='contained' 
                            size='small' 
                            color='error'
                            onClick={resetFormField}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant='contained' 
                            size='small' 
                            type='submit'
                            disabled={!isDirty}
                        >
                            {selectedGstData? 'update':'Save'}
                        </Button>
                    </Grid>
                </Grid>
                
                
            </Box>
        </Card>
    </PermissionGuard>
  );
}

export default AddEdit;
const formatValue = (value) => {
    if (typeof value !== 'string') {
      return value === 0 ? 0 : value?.toString() || '';
    }
    const formatted = value.replace(/^0+(?=\d)/, '').replace(/^\./, '0.');
    return formatted === '' ? '' : formatted;
};